import { trackStructuredEvent } from "./TrackingUtil";

const searchNameString = "search.";
export function trackBundleSelectorToggled(
    bundleListExpanded: boolean,
    originalBettyVariantBundleId: string | undefined | null,
    bettyVariantId: string | undefined,
    bettyVariantBundleIds: string[] | undefined,
    toggleSource: string
) {
    const tags = {
        bundleListExpanded,
        originalBettyVariantBundleId,
        bettyVariantId,
        bettyVariantBundleIds,
        toggleSource
    };
    const structuredData = { tags };
    trackStructuredEvent(searchNameString + "bundleSelectorToggled", structuredData);
}
